import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);

  // Cargar carrito del localStorage al iniciar
  useEffect(() => {
    const savedCart = localStorage.getItem('cart');
    if (savedCart) {
      setCartItems(JSON.parse(savedCart));
    }
  }, []);

  // Guardar carrito en localStorage cuando cambie
  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cartItems));
  }, [cartItems]);

  const addToCart = (estudio, isUrgente = false) => {
    const precio = isUrgente && estudio.precio_urgente ? estudio.precio_urgente : estudio.precio;
    const itemId = `${estudio.id}-${isUrgente ? 'urgente' : 'normal'}`;

    setCartItems(prevItems => {
      const existingItem = prevItems.find(item => item.itemId === itemId);
      
      if (existingItem) {
        return prevItems.map(item =>
          item.itemId === itemId
            ? { ...item, cantidad: item.cantidad + 1 }
            : item
        );
      }

      return [
        ...prevItems,
        {
          itemId,
          estudioId: estudio.id,
          nombre: estudio.nombre,
          precio,
          isUrgente,
          cantidad: 1,
          categoria: estudio.categoria
        }
      ];
    });
  };

  const removeFromCart = (itemId) => {
    setCartItems(prevItems => prevItems.filter(item => item.itemId !== itemId));
  };

  const updateQuantity = (itemId, cantidad) => {
    if (cantidad <= 0) {
      removeFromCart(itemId);
      return;
    }
    setCartItems(prevItems =>
      prevItems.map(item =>
        item.itemId === itemId ? { ...item, cantidad } : item
      )
    );
  };

  const clearCart = () => {
    setCartItems([]);
  };

  const getCartTotal = () => {
    return cartItems.reduce((total, item) => total + (item.precio * item.cantidad), 0);
  };

  const getCartCount = () => {
    return cartItems.reduce((count, item) => count + item.cantidad, 0);
  };

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        removeFromCart,
        updateQuantity,
        clearCart,
        getCartTotal,
        getCartCount
      }}
    >
      {children}
    </CartContext.Provider>
  );
};